import { ALL_EXERCISE_LIST } from '../../constants';

const initialState = {
  data: {},
  loading: false,
  error: {}
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case ALL_EXERCISE_LIST.LOAD:
      return {
        ...state,
        loading: true
      };
    case ALL_EXERCISE_LIST.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false
      };
    case ALL_EXERCISE_LIST.FAIL:
      return {
        ...state,
        error: payload,
        loading: false
      };
    default:
      return state;
  }
}
